// extracted by mini-css-extract-plugin
export default {"menuBlock":"fH-z","title":"gH-z","nav":"hH-z","flexCell":"iH-z","facetLink":"jH-z"};